import React, { useState } from 'react'
import getCloudinaryUrl from '@/utils/getCloudinaryUrl'
import useImageProps from '@/hooks/useImageProps'
import HorizontalScroll from '@/components/HorizontalScroll'
import HorizontalScrollChild from '@/components/HorizontalScrollChild'
import IconPlay from '@/components/IconPlay'
import ImageOverlay from '@/components/ImageOverlay'
import Modal from '@/components/Modal'
import {
  INTERNATIONAL_TOP_DESTINATIONS_CARDS,
  US_TOP_DESTINATIONS_CARDS
} from '../../domain/destinations/constants'

function VideoCards({ showInternationalCards = false }) {
  const [isVisible, setIsVisible] = useState(false)
  const [youTubeId, setYouTubeId] = useState('')

  const cards = showInternationalCards
    ? INTERNATIONAL_TOP_DESTINATIONS_CARDS
    : US_TOP_DESTINATIONS_CARDS

  return (
    <>
      <HorizontalScroll>
        {cards.map(({ description, id, slug, location, thumb }) => (
          <HorizontalScrollChild key={id}>
            <button
              className="block w-full"
              onClick={() => {
                setYouTubeId(id)
                setIsVisible(true)
              }}
            >
              <ImageOverlay
                imageProps={useImageProps({
                  aspectRatio: 'golden',
                  loading: 'lazy',
                  src: getCloudinaryUrl(
                    thumb,
                    'e_gen_restore/q_15,w_640,h_360,c_fill/f_auto'
                  )
                })}
              >
                <IconPlay size="2xl" />
              </ImageOverlay>
            </button>
            <div className="px-2 py-4">
              <a
                href={slug}
                className="cursor-pointer text-lg font-semibold text-gray-1100 underline lg:no-underline hover:lg:underline"
                title={`${location} Rehab Centers`}
              >
                {location}
              </a>
              <p className="text-base text-gray-900">{description}</p>
            </div>
          </HorizontalScrollChild>
        ))}
      </HorizontalScroll>
      <Modal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
      >
        {isVisible && (
          <iframe
            className="rounded-child block aspect-video w-full"
            id="ytplayer"
            type="text/html"
            src={`https://www.youtube.com/embed/${youTubeId}?rel=0&showinfo=0&autohide=1&autoplay=1&vq=hd1080&fs=1`}
            allowFullScreen="allowfullscreen"
            allow="autoplay"
          />
        )}
      </Modal>
    </>
  )
}

export default VideoCards
